export default "__VITE_ASSET__Bfoy5XMF__"